module.exports = __webpack_public_path__ + "static/media/Gotham-Medium.79ee9d36.woff";